import { render } from "./CreatePass.vue?vue&type=template&id=5dd290e2&scoped=true"
import script from "./CreatePass.vue?vue&type=script&lang=js"
export * from "./CreatePass.vue?vue&type=script&lang=js"

import "./CreatePass.vue?vue&type=style&index=0&id=5dd290e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd290e2"]])

export default __exports__